// pages/Parametres.jsx
import React, { useState } from 'react';
import TarifsTab from '../components/parametres/TarifsTab';
import ConfigTab from '../components/parametres/ConfigTab';
import TablesRefTab from '../components/parametres/TablesRefTab';

const C = { primary:'#2E7D32', primaryDark:'#1B5E20', border:'#E0E0E0', light:'#F4F6F9', textDark:'#212121', textMid:'#616161' };

const Parametres = () => {
  const [ongletActif, setOngletActif] = useState('tarifs');

  const onglets = [
    { id: 'tarifs',    label: '💰 Tarification'       },
    { id: 'config',    label: '⚙️ Configuration'       },
    { id: 'tables',    label: '📋 Tables de référence' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: C.light }}>
      {/* Topbar */}
      <div style={{ height: 52, background: '#fff', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', padding: '0 24px', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ fontSize: 13, color: C.textMid, display: 'flex', alignItems: 'center', gap: 6 }}>
          <span>Administration</span>
          <span style={{ color: C.border }}>›</span>
          <span style={{ color: C.textDark, fontWeight: 600 }}>Paramètres</span>
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: '20px auto', padding: '0 24px 40px' }}>
        {/* Onglets */}
        <div style={{ display: 'flex', gap: 3, background: '#fff', padding: 5, borderRadius: 10, border: `1px solid ${C.border}`, marginBottom: 20, width: 'fit-content' }}>
          {onglets.map(o => (
            <button
              key={o.id}
              onClick={() => setOngletActif(o.id)}
              style={{
                padding: '8px 22px', borderRadius: 7, border: 'none', cursor: 'pointer',
                fontSize: 13, fontWeight: 600,
                background: ongletActif === o.id ? C.primary : 'transparent',
                color: ongletActif === o.id ? '#fff' : C.textMid,
              }}
            >
              {o.label}
            </button>
          ))}
        </div>

        {/* Contenu */}
        <div>
          {ongletActif === 'tarifs'  && <TarifsTab />}
          {ongletActif === 'config'  && <ConfigTab />}
          {ongletActif === 'tables'  && <TablesRefTab />}
        </div>
      </div>
    </div>
  );
};

export default Parametres;
